import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import type { Campaign } from 'c-sdk';
import { PermissionName } from 'c-sdk';
import { useUserPermissions } from 'c-auth-module/Hooks';
import { atom_environmentMode } from 'c-main/Pages/Campaign/CampaignOverviewPage/atoms';

/**
 * Classic Postings is behind a per-campaign flag and only means anything for a campaign with
 * classic units. Admins see it regardless until the flag ships (UL-7975).
 */
const useCanSeeClassicPostings = (campaign?: Campaign | null) => {
    const { hasAll } = useUserPermissions();
    const environment = useAtomValue(atom_environmentMode) || 'live';

    return useMemo(() => {
        if (!campaign || !hasAll([PermissionName.ReportingPcareportRead])) return false;
        const hasClassic = (campaign.pca_display_types?.[environment] ?? []).includes('Classic');
        if (!hasClassic) return false;
        return Boolean(campaign.classic_postings_enabled) || hasAll([PermissionName.Admin]);
    }, [campaign, environment, hasAll]);
};

export default useCanSeeClassicPostings;
